export enum OwnerStatus {
  Active = "a",
  NonOwner = "u",
  OnHold = "h",
  NotActive = "n",
}

export enum DriverStatus {
  Active = "working",
  NotActive = "not-working",
  OnHold = "hold",
  OnSilentHold = "silent-hold",
  NotDriver = "not-driver",
}

export enum UserType {
  owner = "owner",
  driver = "driver",
  coordinator = "coordinator",
}

export enum Citizenship {
  Citizen = "c",
  GreenCard = "g",
  EmploymentAuth = "e",
  NotLegal = "n",
}

export const CitizenshipLabel: Record<Citizenship, string> = {
  [Citizenship.Citizen]: "Citizen",
  [Citizenship.GreenCard]: "Green card",
  [Citizenship.EmploymentAuth]: "Employment Auth",
  [Citizenship.NotLegal]: "Not legal",
};

export const DriverStatusOnHold = [DriverStatus.OnHold, DriverStatus.OnSilentHold];
